import { Component, OnInit } from '@angular/core';

import { BeasleyService } from '../../services/beasley/beasley.service';
import { Observable, Subscription } from 'rxjs';
import { AdminService, MetadataService, SessionService, AuthService, ApiService } from '../../services';

@Component({
    selector: 'sn-beasley',
    templateUrl: './beasley.component.html',
    styleUrls: ['./beasley.component.css']
})

export class BeasleyComponent implements OnInit {

    view: string;

    constructor(
        public adminService: AdminService,
        public metadataService: MetadataService,
        public authService: AuthService,
        public apiService: ApiService,
        public sessionService: SessionService,
        public beasleyService: BeasleyService
    ) {
        console.log('BeasleyComponent constructor');
    }

    metaDataSub: Subscription;
    idleTimerSub: Subscription;

    ngOnInit() {
        this.sessionService.log("Meta Data Loading:", new Date());

        this.idleTimerSub = this.sessionService.onIdleTimeout().subscribe(c => {
            this.sessionService.log("Default Session Timeout");
            this.authService.logoff(true);
        });

        this.idleTimerSub = this.sessionService.customIdleLimitReached.subscribe(result => {
            if (result) {
                this.sessionService.log("Custom Session Timeout");
                this.authService.logoff(true);
            }
        });
    }

    loadMetaData(): Observable<any> {
        return this.metadataService.loadMetadata();
    }

    ngOnDestroy() {
        if (this.metaDataSub) this.metaDataSub.unsubscribe();
        if (this.idleTimerSub) this.idleTimerSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/beasley/beasley.component.ts